import * as yup from 'yup';

export const registerFormSchema = (cms, currentYear) => {
    return yup.object().shape({
        profile: yup.object().shape({
            firstName: yup.string().required(cms[36]),
            lastName: yup.string().required(cms[301]),
            dob: yup.object().shape({
                year: yup.number().when('isDobRequired', {
                    is: true,
                    then: yup
                        .number()
                        .typeError(cms[344])
                        .required(cms[338])
                        .min(1900, cms[367])
                        .max(currentYear, cms[368]),
                    otherwise: yup
                        .number()
                        .min(1900, cms[367])
                        .max(currentYear, cms[368])
                        .nullable()
                        .transform((value, originalValue) => (originalValue.trim() === '' ? null : value)),
                }),
                month: yup.number().when('isDobRequired', {
                    is: true,
                    then: yup.number().typeError(cms[345]).required(cms[340]).min(1, cms[369]).max(12, cms[370]),
                    otherwise: yup
                        .number()
                        .min(1, cms[369])
                        .max(12, cms[370])
                        .nullable()
                        .transform((value, originalValue) => (originalValue.trim() === '' ? null : value)),
                }),
                day: yup.number().when('isDobRequired', {
                    is: true,
                    then: yup.number().typeError(cms[346]).required(cms[342]).min(1, cms[371]).max(31, cms[372]),
                    otherwise: yup
                        .number()
                        .min(1, cms[371])
                        .max(31, cms[372])
                        .nullable()
                        .transform((value, originalValue) => (originalValue.trim() === '' ? null : value)),
                }),
            }),
        }),
        email: yup.string().email(cms[38]).required(cms[37]),
        password: yup.string().required(cms[39]),
        passwordConfirmation: yup
            .string()
            .required(cms[366])
            .oneOf([yup.ref('password'), null], cms[365]),
        isSubscribed: yup.boolean(),
        isLegalAccepted: yup.boolean().oneOf([true], cms[2008]),
    });
};
